export default __webpack_public_path__ + "static/Website-d58f93ba35d811586d67fdce7ea01d46.png";